import React from "react";
import Lottie from "lottie-react";
import "./Features.css";
import "./Bubbles.css";
import sportsAnimation from "../animations/sports.json";
import bookingAnimation from "../animations/Appointment booking with smartphone.json";
import walletAnimation from "../animations/Wallet Animation.json";

const animations = {
  "sports": sportsAnimation,
  "Appointment booking with smartphone": bookingAnimation,
  "Wallet Animation": walletAnimation
};

const translations = {
  ar: {
    title: "لماذا MatchUp؟",
    subtitle: "نوفر لك أفضل تجربة لحجز الملاعب",
    features: [
      {
        animation: "sports",
        title: "تنوع الملاعب",
        description:
          "اختر من بين عشرات الملاعب المتنوعة - كرة قدم، سلة، طائرة، وتنس. ملاعب عشبية وصناعية بمواصفات عالمية",
      },
      {
        animation: "Appointment booking with smartphone",
        title: "سهولة الحجز",
        description:
          "احجز ملعبك في ثوانٍ معدودة من خلال واجهة بسيطة وسهلة الاستخدام",
      },
      {
        animation: "Wallet Animation",
        title: "نظام Up Coins",
        description: "محفظة إلكترونية آمنة للدفع السريع",
      },
    ],
  },
  en: {
    title: "Why MatchUp?",
    subtitle: "We provide you with the best stadium booking experience",
    features: [
      {
        animation: "sports",
        title: "Stadium Variety",
        description:
          "Choose from dozens of diverse stadiums - football, basketball, volleyball, and tennis. Natural and artificial turf with international standards across the city",
      },
      {
        animation: "Appointment booking with smartphone",
        title: "Easy Booking",
        description:
          "Book your stadium in seconds through a simple and user-friendly interface",
      },
      {
        animation: "Wallet Animation",
        title: "Up Coins System",
        description:
          "Secure digital wallet for quick payment",
      },
    ],
  },
};

function Features({ language }) {
  const t = translations[language];

  return (
    <section id="features" className="features">
      <div className="bubble bubble-1"></div>
      <div className="bubble bubble-3"></div>
      <div className="bubble bubble-5"></div>
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>
        <div className="features-grid">
          {t.features.map((feature, index) => (
            <div key={index} className="feature-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="feature-animation">
                <Lottie
                  animationData={animations[feature.animation]}
                  loop={true}
                />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
